import { ComponentProps, RefObject, useEffect } from "react"

/**
 * Меняет высоту `textarea` в зависимости от содержимого.
 * Можно использовать с компонентом `TextArea`.
 * @param textAreaValue
 * @param textAreaRef
 */
export function useTextAreaVResizer(
	textAreaValue: ComponentProps<"textarea">["value"],
	textAreaRef: RefObject<HTMLTextAreaElement | null>,
) {
	useEffect(() => {
		if (textAreaRef.current) {
			textAreaRef.current.style.height = "0px" // для корректного значения scrollHeight
			textAreaRef.current.style.height =
				(textAreaRef.current.scrollHeight + 2) + "px"
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [textAreaValue])
}
